export default __webpack_public_path__ + "static/media/tax-rule-products.388b71ae.svg";